<template>
  <header>
    <div class="logo clickable" @click="gohome">
      <img src="@/assets/images/logo_small.png">
    </div>
  </header>
</template>

<script>

export default {
  name: 'common-header',
  components: {},
  data () {
    return {}
  },
  methods: {
    gohome () {
      this.$router.push('/')
    }
  },
  computed: {}
}
</script>

<style lang="scss" scoped>
header {
  padding: 0.5em 0.8em;
  .logo {
    width: 200px;
    height: 100px;
    margin: auto;
    position: relative;
    overflow: hidden;
    img {
      width: 100%;
      position: absolute;
      top: -50%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/Header.vue